module.exports = __webpack_public_path__ + "img/Capricorn.5c02067d.png";